const o="hiero-sdk-js",s="2.79.0";export{o as SDK_NAME,s as SDK_VERSION};
//# sourceMappingURL=version.js.map
